<style>

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    justify-content: space-between !important;
}

</style>

<template>
    <div id="lactationres-icons">
        <head>
      <meta name="description" content="Explore a range of breastfeeding and pumping resources, including guides, classes, and support groups. Click the icons to learn more">
    </head>
        <div class="container" id="icons-text">
            <h1 style="font-size: 2em;" class="display-4 text-center  mt-5 mb-3">Breastfeeding & Pumping</h1>
            <p class="text-center">Click each icon to learn more</p>
            <div class="row mt-5 mb-100" id="resources">
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Best Start</p>
                <router-link to="/lactation_res/best_start">
                <img src="@/assets/site/images/icons/1.svg" alt />
                <h4 class="my-4">
                Successful<br> Breastfeeding
                </h4>
                </router-link>
            </div>
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Maintenance</p>
                <a href="/pdf/breast-pump-cdc cleaning.pdf" 
                    download="breast-pump-cdc cleaning.pdf"
                    rel="nofollow">
                <img src="@/assets/site/images/icons/3.svg" class="img-fluid pb-5" alt />
                <h4 class="mt-4 mb-0 text-blue">Breast Pump<br> Cleaning</h4>
                <p class="text-uppercase mt-0">(PDF)</p>
                </a>
            </div>
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Best Practices</p>
                <a href="/pdf/Best_Practices_for_Milk_Storage.pdf" download="Best_Practices_for_Milk_Storage.pdf"  rel="nofollow">
                <img src="@/assets/site/images/icons/4.svg" class="img-fluid " alt />
                <h4 class="mt-4 mb-0">Milk Storage</h4>
                <p class="text-uppercase mt-0">(PDF)</p>
                </a>
            </div>
            </div>
            <div class="row my-4">
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Know Your Size</p>
                <router-link to="/lactation_res/flange_size">
                <img src="@/assets/site/images/icons/5.svg" alt />
                <h4 class="my-4 text-blue">Flange Size<br>
                    Reference Chart</h4>
                </router-link>
            </div>
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Local & National</p>
                <router-link to="/lactation_res/national">
                <img src="@/assets/site/images/icons/6.svg" class="img-fluid pb-3" alt />
                <h4 class="my-4 text-blue">Breastfeeding<br> Resources</h4>
                </router-link>
            </div>
            <div class="col-md-3 text-center">
                <p class="text-uppercase">Back to Work</p>
                <router-link to="/lactation_res/pumping">
                <img src="@/assets/site/images/icons/7.svg" class="img-fluid" alt />
                <h4 class="my-4 text-blue">Pumping Tips</h4>
                </router-link>
            </div>
         
            </div>
        </div>
        <div class="resources-text text-center pb-3">
              <p style="font-size: 0.7em; line-height: 1.2;">This information is to be used at the discretion of the individual and is not a substitute for medical advice. 
                Please contact your lactation consultant or primary care provider for medical advice. This list of resources was put together by Jodie Dresel RN, IBCLC. </p>
            </div>
    </div>
</template>
<script>
export default {
    name: "LactationresIcons",

};
</script>